
export enum Product {
    'ONE游戏' = 'brand_1',
    '字幕' = 'brand_2',
    '富二代' = 'brand_3',
    '久草视频' = 'brand_4',
    '名优馆' = 'brand_5',
    '博天堂' = 'brand_6',
    '环亚' = 'brand_7',
    '玖玖' = 'brand_8',
    '色色' = 'brand_9',
    '狼少年' = 'brand_10',
    '利来' = 'brand_11',
    '看个球' = 'brand_12',
    'ONE一个' = 'brand_13',
    '香蕉先生' = 'brand_14',
    '青青草' = 'brand_15',
    '小黄鸭' = 'brand_16',
    '果酱视频' = 'brand_17',
    '草莓视频' = 'brand_18',
    '奶茶视频' = 'brand_19',
    '樱桃视频' = 'brand_20',
    '芒果视频' = 'brand_21',
    '玉米视频' = 'brand_22',
    '色中色' = 'brand_23',
    '超碰视频' = 'brand_24',
    'cilicili视频' = 'brand_25',
    '字幕网' = 'brand_27',
    '草榴视频' = 'brand_29',
    '果酱短视频' = 'brand_30',
    '小迪短视频' = 'brand_31',
    '小优短视频' = 'brand_32',
    '字幕网短视频' = 'brand_33',
    '嘿嘿连载' = 'brand_34'
}
export enum AlbumNameBG {
    在线游戏 = 'tie1',
    尽情观赏 = 'tie2',
    赛事下载 = 'tie3',
    资源库 = 'tie4'
}
export const content = {
    [AlbumNameBG.在线游戏]: [
        ['ONE游戏', 'onegame66.com'], ['ONE游戏', 'onegame66.net']
    ],
    [AlbumNameBG.尽情观赏]: [
        ['字幕', 'zimzyz.com'], ['富二代', 'f2dzy8.com'],
        ['久草视频', 'jcczy.com'], ['名优馆', 'nvyzyz.com'],
        ['博天堂', 'bottzy.com'], ['环亚', 'nvyzyz.com'],
        ['玖玖', '9jzy.com'], ['色色', 'ssezyz.com'],
        ['狼少年', 'lsnzyw.com'], ['利来', 'llaizyz.com'],
    ],
    [AlbumNameBG.赛事下载]: [
        ['看个球', 'kgq6.app']
    ],
    [AlbumNameBG.资源库]: [
        ['ONE一个', 'oneyg4.net'], ['香蕉先生', 'xjsp4.app'],
        ['青青草', 'qqc.live'], ['小黄鸭', 'xhynew.com'],
        ['果酱视频', 'gjtv2.vip'], ['草莓视频', 'acm99.app'],
        ['奶茶视频', 'nc99.app'], ['樱桃视频', 'cyt99.app'],
        ['芒果视频', 'cmg99.app'], ['玉米视频', 'cym99.app'],
        ['色中色', 'sis99.app'], ['超碰视频', 'caoporn99.app'],
        ['cilicili视频', 'czhan9.app'], ['名优馆', 'myg23.app'],
        ['字幕网', 'zmw99.app'], ['久草视频', 'jc99.app'],
        ['草榴视频', 'caoliu99.app'], ['果酱短视频', 'qzdsp4.vip'],
        ['小迪短视频', 'xddsp9.app'], ['小优短视频', 'xiaou2.app'],
        ['字幕网短视频', 'zmw10.app'], ['嘿嘿连载', 'heihei99.app']
    ]
}



